import { isDurstMachine } from '../../../helpers/is-durst-machine'
import CalculationPosition from '../../../types/api/calculation-position'
import { DataSourceItem } from './convert-calculations-to-data-source'
import { onAnyStandardCell } from './helpers'
import isCalculation from './is-calculation'

function hasGfInFinishing(machines?: { name?: string }[] | null): boolean {
    return Boolean(machines?.some(m => m.name?.includes('GF')))
}

/** ЦП на Durst без GF — выкатка: в UI разрешены только СМИК/белила. */
export function isColorProofDurstRollout(
    record: Pick<CalculationPosition, 'shipmentType' | 'machine' | 'additional_machines'>
): boolean {
    return (
        record.shipmentType === 'colorProof' &&
        isDurstMachine(record.machine) &&
        !hasGfInFinishing(record.additional_machines)
    )
}

export function onCellUnlessColorProofDurstRollout(record: DataSourceItem) {
    if (isCalculation(record)) {
        return onAnyStandardCell(record)
    }
    return {
        ...onAnyStandardCell(record),
        editable: !isColorProofDurstRollout(record),
    }
}
